const esc = (s) => String(s ?? "")
  .replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");

const hijriFmt = (iso) => {
  try {
    const d = new Date(`${String(iso).trim()}T00:00:00`);
    if (Number.isNaN(d.getTime())) return "";
    return new Intl.DateTimeFormat("ar-SA-u-ca-islamic-umalqura",
      { day: "numeric", month: "long", year: "numeric" }).format(d);
  } catch { return ""; }
};

const DEFAULT_DECISIONS = [
  "يقبل العذر المقدم وتعتمد الإفادة",
  "يحسم عليه وفق لائحة الانضباط الوظيفي",
];

const AR_WEEKDAYS = ["الاثنين", "الثلاثاء", "الأربعاء", "الخميس", "الجمعة", "السبت", "الأحد"];
const dayName = (iso) => {
  const d = new Date(`${String(iso).trim()}T00:00:00`);
  return Number.isNaN(d.getTime()) ? "" : AR_WEEKDAYS[(d.getDay() + 6) % 7];
};

export const TYPE_META = {
  absence: {
    formTitle: "مساءلة غياب", verb: "تغيبت عن العمل", noun: "غيابي",
    countLabel: "أيام الغياب",
    count: (i) => (i.absent_days_list || []).length
      ? i.absent_days_list.map(dayName).join("، ")
      : `${i.absence_days || 0}`,
    body: (i) => (i.absent_days_list || []).length
      ? (i.absent_days_list.length === 1
          ? `من خلال متابعة سجل الدوام تبين غيابكم يوم ${dayName(i.absent_days_list[0])} الموافق ${i.absent_days_list[0]} م ،`
          : `من خلال متابعة سجل الدوام تبين غيابكم أيام ${i.absent_days_list.map(dayName).join("، ")} خلال الفترة الموضحة بعاليه ،`)
      : "من خلال متابعة سجل الدوام تبين غيابكم خلال الفترة الموضحة بعاليه ،",
    decisions: [
      "تحتسب له إجازة مرضية بعد التأكد من نظامية التقرير",
      "يحتسب غيابه من رصيده للإجازات الاضطرارية لقبول عذره إذا كان رصيده يسمح وإلا يحسم عليه",
      "يعتمد الحسم لعدم قبول عذره",
    ],
  },
  lateness: {
    formTitle: "مساءلة تأخر", verb: "تأخرت عن موعد بداية الدوام الرسمي", noun: "تأخري",
    countLabel: "دقائق التأخير",
    count: (i) => `${i.late_minutes || 0} دقيقة`,
    body: (i) => `من خلال متابعة سجل الدوام تبين تأخركم عن موعد بداية الدوام الرسمي بواقع ${i.late_days || 0} أيام وبإجمالي ${i.late_minutes || 0} دقيقة خلال الفترة الموضحة بعاليه ،`,
    decisions: DEFAULT_DECISIONS,
  },
  early_leave: {
    formTitle: "مساءلة انصراف مبكر", verb: "انصرفت قبل نهاية الدوام الرسمي", noun: "انصرافي المبكر",
    countLabel: "دقائق الانصراف المبكر",
    count: (i) => `${i.early_minutes || 0} دقيقة`,
    body: (i) => `من خلال متابعة سجل الدوام تبين انصرافكم المبكر قبل نهاية الدوام الرسمي بواقع ${i.early_days || 0} مرات وبإجمالي ${i.early_minutes || 0} دقيقة خلال الفترة الموضحة بعاليه ،`,
    decisions: DEFAULT_DECISIONS,
  },
  flexible: {
    formTitle: "مساءلة إدارية", verb: "صدر منكم ما يلي", noun: "ما صدر مني",
    countLabel: "الملاحظة",
    count: () => "—",
    body: (i) => `من خلال متابعة سير العمل تبين الآتي : ${esc(i.custom_reason || "")} — خلال الفترة الموضحة بعاليه ،`,
    decisions: DEFAULT_DECISIONS,
  },
  no_checkout: {
    formTitle: "مساءلة خروج بدون بصمة", verb: "لم تسجل بصمة الانصراف", noun: "عدم تسجيلي لبصمة الانصراف",
    countLabel: "عدد الأيام",
    count: (i) => `${i.days_count || 1}`,
    body: (i) => `من خلال متابعة سجل الدوام تبين عدم تسجيلكم بصمة الانصراف رغم تسجيل بصمة الحضور بواقع ${i.days_count || 1} ${(i.days_count || 1) === 1 ? "يوم" : "أيام"} خلال الفترة الموضحة بعاليه ،`,
    decisions: DEFAULT_DECISIONS,
  },
};

const civilBoxes = (id) => {
  const cells = (id || "").toString().replace(/\D/g, "").padStart(10, " ").slice(-10).split("").reverse();
  return cells.map((d) => `<td class="digit">${esc(d.trim())}</td>`).join("");
};

export const letterPageHtml = (inq, branding = {}) => {
  const meta = TYPE_META[inq.inquiry_type] || TYPE_META.lateness;
  const emp = inq.employee_info || {};
  const school = branding.line3 || "";
  const isFlex = inq.inquiry_type === "flexible";
  const periodParts = (inq.period || "").split(" إلى ");
  const hFrom = hijriFmt(periodParts[0]);
  const hTo = hijriFmt(periodParts[1]);
  const hijriPeriod = hFrom && hTo ? `${hFrom} إلى ${hTo}` : hFrom || "";
  const todayHijri = hijriFmt(new Date().toISOString().slice(0, 10));
  const inqHijri = hijriFmt((inq.created_at || "").slice(0, 10));
  const hasReply = !!(inq.reply_text && String(inq.reply_text).trim());
  const replyParas = hasReply ? String(inq.reply_text).trim().split(/\n+/).filter(Boolean) : [];
  const replyDateHijri = hasReply && inq.replied_at ? hijriFmt(String(inq.replied_at).slice(0, 10)) : "";
  const managerName = (branding && branding.manager_name) || "..............................";
  const baseFont = isFlex ? "14.5px" : "15.5px";
  const baseLh = isFlex ? "1.45" : "1.55";
  const logoSize = isFlex ? 120 : 135;
  const ministrySize = logoSize + 25;
  return `<div class="letter-page" style="font-size:${baseFont};line-height:${baseLh}">
  <div class="brand">
    <div class="lines">
      <div>${esc(branding.line1 || "المملكة العربية السعودية")}</div>
      <div>${esc(branding.line2 || "وزارة التعليم")}</div>
      ${school ? `<div>${esc(school)}</div>` : ""}
    </div>
    <div>${branding.logo_ministry ? `<img src="${branding.logo_ministry}" style="width:${ministrySize}px;height:${ministrySize}px;object-fit:contain">` : ""}</div>
    <div>${branding.logo_school ? `<img src="${branding.logo_school}" style="width:${logoSize}px;height:${logoSize}px;object-fit:contain">` : ""}</div>
  </div>
  <div class="brand-divider"></div>
  ${todayHijri ? `<div class="hdate">التاريخ : ${esc(todayHijri)}</div>` : ""}
  <h1 class="title">اسم النموذج : ${esc(meta.formTitle)}</h1>

  <table class="box"><tr><td class="lbl">المدرسة</td><td>${esc(school)}</td></tr></table>
  <table class="box"><tr><td class="lbl">السجل المدني</td>${civilBoxes(emp.employee_id || inq.employee_id)}</tr></table>

  <table class="info">
    <tr><th>الاسم</th><th>التخصص</th><th>المستوى / المرتبة</th><th>رقم الوظيفة</th><th>العمل الحالي</th><th>${esc(meta.countLabel)}</th></tr>
    <tr>
      <td>${esc(inq.employee_name)}</td>
      <td>${esc(emp.specialty || "")}</td>
      <td>${esc(emp.rank_level || "")}</td>
      <td>${esc(emp.job_number || "")}</td>
      <td>${esc(emp.current_job || emp.department || "")}</td>
      <td>${esc(meta.count(inq))}</td>
    </tr>
  </table>

  <p class="daterange">إنه في الفترة المحددة ${inq.period ? `( ${esc(inq.period)} م )` : ""}${hijriPeriod ? ` الموافق <span style="font-size:14px">( ${esc(hijriPeriod)} )</span>` : ""}</p>

  <p class="sec">1 ) طلب الإفادة :</p>
  <div class="mukarram"><span>المكرم / ${esc(inq.employee_name)}</span><span>وفقه الله</span></div>
  <p class="body-p">السلام عليكم ورحمة الله وبركاته وبعـــد :</p>
  <p class="body-p">${meta.body(inq)}</p>
  <p class="body-p">آمل الإفادة عن أسباب ذلك وعليكم تقديم ما يؤيد عذركم خلال أسبوع من تاريخه ، علماً بأنه في حالة عدم الالتزام سيتم اتخاذ اللازم حسب التعليمات .</p>
  <div class="sigrow"><span>اسم الرئيس المباشر : ${esc(managerName)}</span><span>التوقيع : ${(branding && branding.signature) ? `<img class="mgr-sig" src="${branding.signature}" alt="التوقيع">` : "......................"}</span><span>التاريخ : ${inqHijri ? esc(inqHijri) : "&nbsp;&nbsp; / &nbsp;&nbsp; / 14&nbsp;&nbsp;هـ"}</span></div>

  <hr class="sep">

  <p class="sec">2 ) الإفادة :</p>
  <div class="mukarram"><span>المكرم / قائد المدرسة</span><span>وفقه الله</span></div>
  <p class="body-p">السلام عليكم ورحمة الله وبركاته وبعد :</p>
  <p class="body-p">أفيدكم أن ${esc(meta.noun)} كان للأسباب التالية :</p>
  ${hasReply
    ? `<div class="reply-text">${replyParas.map((p) => `<p class="body-p">${esc(p)}</p>`).join("")}</div>`
    : `<div class="dots"></div>
  <div class="dots"></div>`}
  <p class="body-p">وسأقوم بتقديم ما يثبت ذلك خلال أسبوع من تاريخه .</p>
  <div class="sigrow"><span>الاسم : ${esc(inq.employee_name || "..............................")}</span><span>التوقيع : ${inq.reply_signature_data ? `<img class="reply-sig" src="${inq.reply_signature_data}" alt="التوقيع">` : "......................"}</span><span>التاريخ : ${replyDateHijri ? esc(replyDateHijri) : "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; / &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; / &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;14هـ"}</span></div>

  <hr class="sep">

  <p class="sec">3 ) مدير المدرسة :</p>
  ${meta.decisions.map((d) => `<div class="decision"><span class="cbx"></span><span>${esc(d)}</span></div>`).join("")}
  <div class="sigrow"><span>اسم مدير المدرسة : ${esc((branding && branding.manager_name) || "..............................")}</span><span>التوقيع : ......................</span><span>التاريخ : &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; / &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; / &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;14هـ</span></div>
  ${(branding && branding.stamp) ? `<div class="sigrow"><span></span><span>الختم : <img class="stamp-img" src="${branding.stamp}" alt="الختم"></span><span></span></div>` : ""}

  ${inq.inquiry_type === "absence" ? `<div class="notes">
    <b>ملاحظات هامة :</b><br>
    تستكمل الاستمارة من المدير المباشر و إصدار القرار بموجبه<br>
    إذا سبق عطلة نهاية الأسبوع غياب و ألحقها غياب تحتسب مدة الغياب كاملة<br>
    يجب أن يوضح المتغيب أسباب غيابه فور تسلمه الاستمارة ويعيدها لمدير المباشر<br>
    يعطى المتغيب مدة أسبوع لتقديم ما يريد عذره فإذا انقضت المدة الزمنية تستكمل الاستمارة ويتم الحسم
  </div>` : ""}
</div>`;
};

const attachmentPagesHtml = (inq) => {
  const imgs = inq.reply_attachment_images || [];
  return imgs.map((src, i) => `<div class="letter-page attach-page">
  <p class="attach-title">مرفق : مستند العذر المقدم من ${esc(inq.employee_name || "")}${imgs.length > 1 ? ` ( صفحة ${i + 1} من ${imgs.length} )` : ""}</p>
  <img class="attach-img" src="${src}" alt="مستند العذر">
</div>`).join("\n");
};

const LETTER_STYLES = `
  @page { size: A4 portrait; margin: 8mm 10mm; }
  * { box-sizing: border-box; margin: 0; }
  body { font-family: 'Amiri', 'Traditional Arabic', 'Sakkal Majalla', 'Segoe UI', Tahoma, sans-serif; color: #000; }
  .letter-page { page-break-after: always; }
  .letter-page:last-of-type { page-break-after: auto; }
  .brand { display: grid; grid-template-columns: 1fr 1fr 1fr; align-items: center; justify-items: center; }
  .brand-divider { border-top: 2.2px solid #064E3B; border-bottom: 0.9px solid #064E3B; height: 3px; margin: 3px 0 5px; }
  .brand .lines { display: flex; flex-direction: column; align-items: center; justify-content: center; align-self: stretch; text-align: right; font-weight: bold; font-size: 14px; line-height: 1.6; }
  .school { text-align: center; color: #000; font-weight: bold; font-size: 18px; margin: 1px 0 3px; }
  h1.title { text-align: center; color: #C00000; font-size: 22px; font-weight: bold; text-decoration: underline; margin: 0 0 4px; }
  .hdate { text-align: left; font-size: 14px; font-weight: bold; margin: 0 0 2px; }
  table { width: 100%; border-collapse: collapse; margin-bottom: 6px; }
  .box td { border: 2.5px solid #000; padding: 2px 10px; }
  .box .lbl { width: 110px; text-align: center; font-weight: bold; font-size: 16px; }
  td.digit { border: 2.5px solid #000; width: 30px; height: 34px; text-align: center; font-weight: bold; font-size: 16px; }
  .info th, .info td { border: 2.5px solid #000; padding: 2px 6px; text-align: center; font-size: 14px; line-height: 1.4; }
  .info th { font-weight: bold; }
  .daterange { font-size: 16px; font-weight: bold; margin: 4px 0; }
  .hijri { display: inline-block; border-bottom: 1.5px solid #000; min-width: 120px; text-align: center; }
  .sec { font-weight: bold; text-decoration: underline; font-size: 16px; margin: 6px 0 2px; }
  .mukarram { display: flex; justify-content: space-between; font-size: 1em; }
  .body-p { text-align: justify; font-size: 1em; }
  .sigrow { display: flex; justify-content: space-between; margin: 5px 0 0; font-size: 1em; }
  hr.sep { border: 0; border-top: 2px solid #000; margin: 4px 0; }
  .dots { border-bottom: 1.5px dotted #000; height: 16px; margin: 4px 0; }
  .reply-text { margin: 4px 0; padding: 2px 4px; }
  .reply-sig { max-height: 56px; max-width: 170px; object-fit: contain; vertical-align: middle; }
  .mgr-sig { display: inline-block; vertical-align: middle; max-height: 100px; max-width: 280px; object-fit: contain; margin: -35px 0; }
  .stamp-img { max-height: 110px; max-width: 180px; object-fit: contain; vertical-align: middle; }
  .decision { display: flex; align-items: flex-start; gap: 8px; margin: 2px 0; font-size: 0.97em; }
  .cbx { display: inline-block; width: 15px; height: 15px; border: 1.8px solid #000; margin-top: 7px; flex-shrink: 0; }
  .notes { margin-top: 6px; font-size: 12.5px; line-height: 1.6; }
  .notes b { text-decoration: underline; font-size: 14px; }
  .attach-page { text-align: center; }
  .attach-title { text-align: right; font-weight: bold; font-size: 16px; margin: 2px 0 8px; }
  .attach-img { max-width: 100%; max-height: 245mm; object-fit: contain; }
`;

export const LETTER_INLINE_STYLES = `
  .letter-inline { font-family: 'Amiri', 'Traditional Arabic', 'Sakkal Majalla', 'Segoe UI', Tahoma, sans-serif; color: #000; direction: rtl; }
  .letter-inline * { box-sizing: border-box; margin: 0; }
  .letter-inline .letter-page { width: 770px; }
  .letter-inline .brand { display: grid; grid-template-columns: 1fr 1fr 1fr; align-items: center; justify-items: center; }
  .letter-inline .brand-divider { border-top: 2.2px solid #064E3B; border-bottom: 0.9px solid #064E3B; height: 3px; margin: 3px 0 5px; }
  .letter-inline .brand .lines { display: flex; flex-direction: column; align-items: center; justify-content: center; align-self: stretch; text-align: right; font-weight: bold; font-size: 14px; line-height: 1.6; }
  .letter-inline .school { text-align: center; color: #000; font-weight: bold; font-size: 18px; margin: 1px 0 3px; }
  .letter-inline h1.title { text-align: center; color: #C00000; font-size: 22px; font-weight: bold; text-decoration: underline; margin: 0 0 4px; }
  .letter-inline .hdate { text-align: left; font-size: 14px; font-weight: bold; margin: 0 0 2px; }
  .letter-inline table { width: 100%; border-collapse: collapse; margin-bottom: 6px; }
  .letter-inline .box td { border: 2.5px solid #000; padding: 2px 10px; }
  .letter-inline .box .lbl { width: 110px; text-align: center; font-weight: bold; font-size: 16px; }
  .letter-inline td.digit { border: 2.5px solid #000; width: 30px; height: 34px; text-align: center; font-weight: bold; font-size: 16px; }
  .letter-inline .info th, .letter-inline .info td { border: 2.5px solid #000; padding: 2px 6px; text-align: center; font-size: 14px; line-height: 1.4; }
  .letter-inline .info th { font-weight: bold; }
  .letter-inline .daterange { font-size: 16px; font-weight: bold; margin: 4px 0; }
  .letter-inline .hijri { display: inline-block; border-bottom: 1.5px solid #000; min-width: 120px; text-align: center; }
  .letter-inline .sec { font-weight: bold; text-decoration: underline; font-size: 16px; margin: 6px 0 2px; }
  .letter-inline .mukarram { display: flex; justify-content: space-between; font-size: 1em; }
  .letter-inline .body-p { text-align: justify; font-size: 1em; }
  .letter-inline .sigrow { display: flex; justify-content: space-between; margin: 5px 0 0; font-size: 1em; }
  .letter-inline hr.sep { border: 0; border-top: 2px solid #000; margin: 4px 0; }
  .letter-inline .dots { border-bottom: 1.5px dotted #000; height: 16px; margin: 4px 0; }
  .letter-inline .reply-text { margin: 4px 0; padding: 2px 4px; }
  .letter-inline .reply-sig { max-height: 56px; max-width: 170px; object-fit: contain; vertical-align: middle; }
  .letter-inline .mgr-sig { display: inline-block; vertical-align: middle; max-height: 100px; max-width: 280px; object-fit: contain; margin: -35px 0; }
  .letter-inline .stamp-img { max-height: 110px; max-width: 180px; object-fit: contain; vertical-align: middle; }
  .letter-inline .decision { display: flex; align-items: flex-start; gap: 8px; margin: 2px 0; font-size: 0.97em; }
  .letter-inline .cbx { display: inline-block; width: 15px; height: 15px; border: 1.8px solid #000; margin-top: 7px; flex-shrink: 0; }
  .letter-inline .notes { margin-top: 6px; font-size: 12.5px; line-height: 1.6; }
  .letter-inline .notes b { text-decoration: underline; font-size: 14px; }
  .letter-inline .attach-page { text-align: center; margin-top: 10px; }
  .letter-inline .attach-title { text-align: right; font-weight: bold; font-size: 16px; margin: 2px 0 8px; }
  .letter-inline .attach-img { max-width: 100%; object-fit: contain; }
`;

const docWrap = (title, pages) => `<!doctype html><html dir="rtl" lang="ar"><head><meta charset="utf-8"><title>${esc(title)}</title>
<link href="https://fonts.googleapis.com/css2?family=Amiri:wght@400;700&display=swap" rel="stylesheet">
<style>${LETTER_STYLES}</style></head><body>
${pages}
</body></html>`;

export const letterHtml = (inq, branding = {}) => {
  const meta = TYPE_META[inq.inquiry_type] || TYPE_META.lateness;
  return docWrap(`${meta.formTitle} — ${inq.employee_name || ""}`,
    letterPageHtml(inq, branding) + attachmentPagesHtml(inq));
};

export const lettersHtml = (inquiries, branding = {}) =>
  docWrap("مساءلات الفترة",
    inquiries.map((i) => letterPageHtml(i, branding) + attachmentPagesHtml(i)).join("\n"));
